import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import HeroSection from "../components/BrandVault/HeroSection"
import FeaturedContent from "../components/BrandVault/FeaturedContent"
import FeaturedContentCard from "../components/BrandVault/FeaturedContentCard"
import Resources from "../components/BrandVault/Resources"
import BlogList from '../components/BrandVault/BlogList'


const BrandVault = () => {
  const location = useLocation(); 

  useEffect(() => {
    if (location.hash) {
      const id = decodeURIComponent(location.hash.substring(1));
      const element = document.getElementById(id);
      if (element) {
        const timer = setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [location]);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Brand Vault | Brand Acumen</title>
          <meta name="description" content="Explore the services offered by Brand Acumen." />
          <meta name="description" content="Welcome to the homepage of Brand Acumen." />
          <meta property="og:title" content="Home | Brand Acumen" />
          <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
          <meta property="og:image" content="/og-image.jpg" />
          <meta property="og:url" content="https://brandacumen.co/" />
          <meta property="og:type" content="website" />

          {/* Twitter */}
          <meta name="twitter:title" content="Home | Brand Acumen" />
          <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
          <meta name="twitter:image" content="/og-image.jpg" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <HeroSection />
        <FeaturedContent />
        <FeaturedContentCard />
        <BlogList />
        <Resources />
        
      </HelmetProvider>
    </>
  );
};

export default BrandVault;